// import { Group } from "./Group";
import { Outlined } from "./Outlined";
import { Filled } from "./Filled";

export const ComponentContainer = { outlined: Outlined, filled: Filled };
